<template>
  <div class="animated fadeIn">
    <loader :show="enviando" />
    <b-row>
      <b-col sm="12" class="text-center">
        <h4 style="text-align: center">17. APOYOS</h4>
      </b-col>
    </b-row>
    <br />

    <b-row v-for="(item, index) in apoyo.apoyo" :key="index">
      <b-col sm="2">
        <b-form-group>
          <label>Tipo Operación:</label>
          <b-form-select
          :disabled="status === 'Concluida'"
            @change="cambiosapoyo[index] = true"
            v-model="item.tipoOperacion"
            :options="tipoOperacion"
            class="mb-3"
          />
        </b-form-group>
      </b-col>

      <b-col md="3">
        <b-form-group label="Beneficiario Programa: ">
          <b-form-select
          :disabled="status === 'Concluida'"
            v-model="item.beneficiarioPrograma.clave"
            :options="beneficiarioPrograma"
            class="mb-3"
            @change="(cambiosapoyo[index] = true), encuentraBeneficiario(index)"
            text-field="valor"
            value-field="clave"
          ></b-form-select>
        </b-form-group>
      </b-col>

      <b-col md="3">
        <b-form-group>
          <label for="nombreins">Nombre del programa:</label>
          <b-form-input
          :disabled="status === 'Concluida'"
            v-model="item.nombrePrograma"
            type="text"
            placeholder="Ingrese..."
            @change="cambiosapoyo[index] = true"
          ></b-form-input>
        </b-form-group>
      </b-col>

      <b-col md="3">
        <b-form-group>
          <label for="nombreins">Nombre de la institución:</label>
          <b-form-input
          :disabled="status === 'Concluida'"
            v-model="item.institucionOtorgante"
            type="text"
            placeholder="Ingrese..."
            @change="cambiosapoyo[index] = true"
          ></b-form-input>
        </b-form-group>
      </b-col>

      <b-col md="3">
        <b-form-group label="Tipo de apoyo: ">
          <b-form-select
          :disabled="status === 'Concluida'"
            v-model="item.tipoApoyo.clave"
            :options="tipoApoyo"
            class="mb-3"
            @change="(cambiosapoyo[index] = true), encuentraApoyo(index)"
            text-field="valor"
            value-field="clave"
          ></b-form-select>
        </b-form-group>
      </b-col>

      <b-col md="3">
        <b-form-group label="Nivel orden de gobierno: ">
          <b-form-select
          :disabled="status === 'Concluida'"
            v-model="item.nivelOrdenGobierno"
            :options="nivelOrdenGobierno"
            class="mb-3"
            @change="cambiosapoyo[index] = true"
          ></b-form-select>
        </b-form-group>
      </b-col>

      <b-col md="3">
        <b-form-group label="Forma Recepción: ">
          <b-form-select
          :disabled="status === 'Concluida'"
            v-model="item.formaRecepcion"
            :options="formaRecepcion"
            class="mb-3"
            @change="cambiosapoyo[index] = true"
          >
          
          </b-form-select>
        </b-form-group>
      </b-col>

      <b-col md="6" v-show="item.formaRecepcion === 'ESPECIE'">
        <b-form-group label="Especifique apoyo: ">
          <b-form-input
          :disabled="status === 'Concluida'"
            v-model="item.especifiqueApoyo"
            type="text"
            placeholder="Ingrese..."
            @change="cambiosapoyo[index] = true"
          ></b-form-input>
        </b-form-group>
      </b-col>

      <b-col md="3">
        <b-form-group>
          <label for="montomen">Monto mensual:</label>
          <b-form-input
          :disabled="status === 'Concluida'"
            v-model="item.montoApoyoMensual.valor"
            type="text"
            placeholder="Ingrese..."
            @change="cambiosapoyo[index] = true"
          ></b-form-input>
        </b-form-group>
      </b-col>
      <b-col md="2">
        <b-form-group>
          <label for="moneda">Moneda:</label>
          <b-form-input type="text" value="MXN" disabled></b-form-input>
        </b-form-group>
      </b-col>

      <b-col md="12" class="text-left"> </b-col>
      <b-col md="6" class="text-left">
        <b-button
        v-if="status !== 'Concluida'"
          size="sm"
          variant="primary"
          @click="modificarapoyo(item._id, index)"
          :disabled="enviando"
          >Guarda apoyo</b-button
        >
        <br />
        <p v-show="cambiosapoyo[index]" class="error-text">
          <i>No se han guardado los cambios</i>
        </p>
        <br />
      </b-col>
      <b-col md="6" class="text-right">
        <b-button
        v-if="status !== 'Concluida'"
          variant="danger"
          size="sm"
          @click="eliminarapoyo(item._id, index)"
          >Eliminar apoyo</b-button
        >
      </b-col>

      <br />
      <br />
      <b-col md="12">
        <div class="customHr">.</div>
      </b-col>
      <br />
    </b-row>

    <b-row>
      <b-col md="12">
        <b-button v-if="status !== 'Concluida'" variant="primary" size="sm" @click="nuevoElemento()"
          >Agregar Apoyo</b-button
        >
      </b-col>
    </b-row>

    <br />
    <b-row>
      <b-col md="12">
        <b-form-group>
          <label for="aclara">ACLARACIONES / OBSERVACIONES</label>
          <b-form-input
          :disabled="status === 'Concluida'"
            @change="cambios = true"
            v-model="apoyo.aclaracionesObservaciones"
            type="text"
            placeholder="Ingrese..."
          ></b-form-input>
        </b-form-group>
      </b-col>
    </b-row>

    <br />
    <br />
    <b-row>
      <b-col md="4">
        <b-button variant="success" @click="verSeccion(0)" :disabled="enviando"
          >Regresar al índice</b-button
        >
      </b-col>
      <b-col md="4" style="text-align: center">
        <b-button
        v-if="status !== 'Concluida'"
          variant="primary"
          @click="actualizarAclaraciones()"
          :disabled="enviando"
          >Guardar cambios</b-button
        >
        <br />
        <p v-show="cambios" class="error-text">
          <i>No se han guardado los cambios</i>
        </p>
      </b-col>
      <b-col md="2">
        <b-button

          variant="secondary"
          @click="verSeccion(16)"
          :disabled="enviando"
          >Anterior</b-button
        >
      </b-col>
      <b-col md="2">
        <b-button
    
          class="pull-right"
          variant="secondary"
          @click="verSeccion(18)"
          :disabled="enviando"
          >Siguiente</b-button
        >
      </b-col>
    </b-row>
  </div>
</template>

<script>
import axios from "axios";
import swal from "sweetalert";
import Loader from "../../../views/Loader";
import { mapGetters } from "vuex";

import { Datetime } from "vue-datetime";
import "vue-datetime/dist/vue-datetime.css";

export default {
  props: ["apoyo","status"],
  components: {
    Datetime,
    Loader
  },
  computed: {
    ...mapGetters(["httpURL", "sessionToken"])
  },
  data: function() {
    return {
      titulo: this.$route.name,
      enviando: false,
      cambios: false,
      cambiosapoyo: [],
      tipoOperacion: ["AGREGAR", "MODIFICAR", "SIN_CAMBIOS", "BAJA"],
      beneficiarioPrograma: [
        { clave: "DC", valor: "DECLARANTE" },
        { clave: "CY", valor: "CONYUGE" },
        { clave: "CON", valor: "CONCUBINA O CONCUBINARIO" },
        { clave: "CONV", valor: "CONVIVIENTE" },
        { clave: "HIJ", valor: "HIJO(A)" },
        { clave: "HER", valor: "HERMANO(A)" },
        { clave: "CU", valor: "CUÑADO(A)" },
        { clave: "MA", valor: "MADRE" },
        { clave: "PA", valor: "PADRE" },
        { clave: "TIO", valor: "TÍO(A)" },
        { clave: "PRI", valor: "PRIMO(A" },
        { clave: "SOB", valor: "SOBRINO(A" },
        { clave: "AHI", valor: "AHIJADO(A)" },
        { clave: "NUE", valor: "NUERA" },
        { clave: "YER", valor: "YERNO" },
        { clave: "ABU", valor: "ABUELO(A)" },
        { clave: "NIE", valor: "NIETO(A)" },
        { clave: "OTRO", valor: "OTRO(A)" }
      ],
      nivelOrdenGobierno: ["FEDERAL", "ESTATAL", "MUNICIPAL_ALCALDIA"],
      tipoApoyo: [
        { clave: "SUB", valor: "SUBSIDIO" },
        { clave: "SER", valor: "SERVICIO" },
        { clave: "OBRA", valor: "OBRA" },
        { clave: "OTRO", valor: "OTRO" }
      ],
      formaRecepcion: ["MONETARIO", "ESPECIE"]
    };
  },
  methods: {
    //////////////////////////////////////////////////////////////////////////////////desiciones////////////////////////////////////////////////////////////////

    checaindex(index) {
      if (Number.isInteger(index)) {
        return this.cambiosapoyo[index];
      }

      return false;
    },

    especificaForma(index) {
      if (this.apoyo.apoyo[index].formaRecepcion !== "ESPECIE") {
        this.apoyo.apoyo[index].especifiqueApoyo =
          "NO ES NECESARIO ESPECIFICAR";
      }
    },
    encuentraBeneficiario(index) {
      let indice;
      indice = this.beneficiarioPrograma.findIndex(
        x => x.clave === this.apoyo.apoyo[index].beneficiarioPrograma.clave
      );
      this.apoyo.apoyo[
        index
      ].beneficiarioPrograma.valor = this.beneficiarioPrograma[indice].valor;
    },
    encuentraApoyo(index) {
      let indice;
      indice = this.tipoApoyo.findIndex(
        x => x.clave === this.apoyo.apoyo[index].tipoApoyo.clave
      );
      this.apoyo.apoyo[index].tipoApoyo.valor = this.tipoApoyo[indice].valor;
    },

    modificarapoyo(idParti, index) {
      axios
        .put(
          this.httpURL +
            "/declaraciones/V2/apoyos/" +
            this.$route.params.id +
            "/apoyo/" +
            idParti,
          {
            tipoOperacion: this.apoyo.apoyo[index].tipoOperacion,
            beneficiarioProgramaClave: this.apoyo.apoyo[index]
              .beneficiarioPrograma.clave,
            beneficiarioProgramaValor: this.apoyo.apoyo[index]
              .beneficiarioPrograma.valor,
            nombrePrograma: this.apoyo.apoyo[index].nombrePrograma,
            institucionOtorgante: this.apoyo.apoyo[index].institucionOtorgante,
            nivelOrdenGobierno: this.apoyo.apoyo[index].nivelOrdenGobierno,
            tipoApoyoClave: this.apoyo.apoyo[index].tipoApoyo.clave,
            tipoApoyoValor: this.apoyo.apoyo[index].tipoApoyo.valor,
            formaRecepcion: this.apoyo.apoyo[index].formaRecepcion,
            montoApoyoMensualValor: this.apoyo.apoyo[index].montoApoyoMensual
              .valor,
            montoApoyoMensualMoneda: "MXN",
            especifiqueApoyo: this.apoyo.apoyo[index].especifiqueApoyo
          },
          { headers: { token: this.sessionToken } }
        )
        .then(res => {
          
          if (res.data.ok == true) {
            this.$notify({
              group: "foo",
              type: "success",
              duration: 2500,
              speed: 1000,
              text: res.data.mensaje
            });
          }
          this.enviando = false;
          this.cambiosapoyo[index] = false;
          this.$forceUpdate();
        })
        .catch(error => {
          this.$notify({
            group: "foo",
            type: "error",
            duration: 2500,
            speed: 1000,
            text: "No se pudo editar la inversión."
          });
          this.enviando = false;
        });
    },

    eliminarapoyo(idParti, index) {
      swal({
        text: "¿Está seguro en eliminar el apoyo?",
        icon: "warning",
        buttons: true,
        dangerMode: true
      }).then(willDelete => {
        if (willDelete) {
          axios
            .delete(
              this.httpURL +
                "/declaraciones/V2/apoyos/" +
                this.$route.params.id +
                "/apoyo/" +
                idParti,
              { headers: { token: this.sessionToken } }
            )
            .then(res => {
              
              if (res.data.ok == true) {
                this.$notify({
                  group: "foo",
                  type: "success",
                  duration: 2500,
                  speed: 1000,
                  text: res.data.mensaje
                });
                this.apoyo.apoyo.splice(index, 1);
                this.cambiosapoyo.splice(index, 1);
              }
              this.enviando = false;
            })
            .catch(error => {
              this.$notify({
                group: "foo",
                type: "error",
                duration: 2500,
                speed: 1000,
                text: "No se pudo guardar la sección."
              });
              this.enviando = false;
              
            });
        }
      });
    },

    nuevoElemento() {
      axios
        .post(
          this.httpURL +
            "/declaraciones/V2/apoyos/" +
            this.$route.params.id +
            "/apoyo",
          {},
          { headers: { token: this.sessionToken } }
        )
        .then(res => {
       
          if (res.data.ok == true) {
            this.$notify({
              group: "foo",
              type: "success",
              duration: 2500,
              speed: 1000,
              text: res.data.mensaje
            });
            this.apoyo.apoyo.push(res.data.apoyo);
            this.cambiosapoyo.push(false);
          }
          this.enviando = false;
        })
        .catch(error => {
          this.$notify({
            group: "foo",
            type: "error",
            duration: 2500,
            speed: 1000,
            text: "No se pudo crear nuevo elemento."
          });
          this.enviando = false;
        });
    },
    /////////////////////////////////////////////////////////////aclarariones observacionales///////////////////////////////////////////////////////////////////////////////////
    actualizarAclaraciones() {
      this.enviando = true;
      axios
        .put(
          this.httpURL +
            "/declaraciones/V2/apoyos/" +
            this.$route.params.id +
            "/aclaracionesObservaciones",
          {
            aclaracionesObservaciones: this.apoyo.aclaracionesObservaciones,
            ninguno: ""
          },
          { headers: { token: this.sessionToken } }
        )
        .then(res => {
       
          if (res.data.ok == true) {
            this.$notify({
              group: "foo",
              type: "success",
              duration: 2500,
              speed: 1000,
              text: res.data.mensaje
            });
          }
          this.enviando = false;
          this.cambios = false;
        })
        .catch(error => {
          this.$notify({
            group: "foo",
            type: "error",
            duration: 2500,
            speed: 1000,
            text: "No se pudo guardar la sección."
          });
          this.enviando = false;
        });
    },

    //////////////////////////////////////////////////////////////////////////////////////////////////////

    verSeccion(sec) {
      this.$emit("verSeccion", sec);
    }
  },
  created() {
 
    if (this.apoyo.apoyo.length > 0) {
      this.apoyo.apoyo.forEach(Element => {
        this.cambiosapoyo.push(false);
      });
    }
  }
};
</script>

<style>
.customHr {
  width: 100%;
  font-size: 1px;
  color: rgba(0, 0, 0, 0);
  line-height: 1px;

  background-color: grey;
  margin-top: 0px;
  margin-bottom: 10px;
}
.error-texr {
  color: #ff0000;
}
</style>
